import styled from 'styled-components';

export const Main = styled.main`
  max-width: 1900px;
  min-width: 190px;
  margin: 0 auto;
  ${({ $customStyle }) => $customStyle || ''}
  ${({ $responsive }) => $responsive || ''}
`;
